import { render, staticRenderFns } from "./StrictForm.vue?vue&type=template&id=b03fa446&scoped=true&"
import script from "./StrictForm.vue?vue&type=script&lang=js&"
export * from "./StrictForm.vue?vue&type=script&lang=js&"
import style0 from "./StrictForm.vue?vue&type=style&index=0&id=b03fa446&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03fa446",
  null
  
)

export default component.exports